import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { StihlFeriaDTO, StihlFeriaOrderDTO, StihlFeriaOrderFilterDTO, StihlFeriaOrderPostDTO } from '../models/stihl-feria-dto';
import { ChangeOrderDTO } from '../models/change-order-dto';

@Injectable({
  providedIn: 'root'
})

export class FeriaService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlFeria/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<StihlFeriaDTO> {
    return this.http.get<StihlFeriaDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
  }

  public getDataTableAdminOrder(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableAdminOrder/', data);
  }

  public changeOrder(data: ChangeOrderDTO[]): any {
    return this.http.post<any>(this.pathAPI + this.controller + 'ChangeOrder', data);
  }

  public GetStihlActiveFeria(): Observable<StihlFeriaDTO[]> {
    return this.http.get<StihlFeriaDTO[]>(this.pathAPI + this.controller + 'GetStihlActiveFeria/');
  }

  public postFeriaOrder(order: StihlFeriaOrderPostDTO): Observable<StihlFeriaOrderDTO> {
    return this.http.post<StihlFeriaOrderDTO>(this.pathAPI + this.controller + 'InsertOrder/', order);
  }

  public updateFeriaOrder(id: string, data: StihlFeriaOrderDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'UpdateOrder/' + id, data);
  }

  public getFeriaOrder(id: string): Observable<StihlFeriaOrderDTO> {
    return this.http.get<StihlFeriaOrderDTO>(this.pathAPI + this.controller + 'GetOrder/' + id);
  }

  public changeStatusOrder(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatusOrder/' + id + '/' + idStatus, null);
  }

  public getDataTableOrder(data: any, filter?: StihlFeriaOrderFilterDTO): Observable<DataTablesResponse> {
    let query = this.buildFilterQuery(filter);
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableOrder' + query, data);
  }

  public getDataTableOrderExcel(filter: StihlFeriaOrderFilterDTO): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    return this.http.post<Blob>(this.pathAPI + this.controller + 'GetDataTableOrderExcel', filter, requestOptions);
  }

  private buildFilterQuery(filter?: StihlFeriaOrderFilterDTO): string {
    if (!filter)
      return '';

    let params: string[] = [];
    if (filter.IdDistributor != null)
      params.push('IdDistributor=' + filter.IdDistributor);
    if (filter.IdStatus != null)
      params.push('IdStatus=' + filter.IdStatus);

    return params.length > 0 ? '?' + params.join('&') : '';
  }

}
